import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useTranslation } from 'app/lang';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import { getBackendServerUrl } from 'app/ssr/utils';
import { getModalLink } from 'app/widgets/DownloadModal';
import { QRCode } from 'app/widgets/QRCode';

import dictionary from './MobileBanner.dictionary.json';

import styles from './MobileBanner.module.scss';

const FROM_WHERE = 'footer';

export const MobileBanner: FC = () => {
  const { t, lang } = useTranslation();

  const isQRtoInstructions = useFeatureFlag(FeatureFlag.QR_TO_INSTRUCTIONS);
  const mobileWebAppURL = getUniversalEnv('MOBILE_WEB_APP_URL');
  const downloadModalLink = getModalLink(FROM_WHERE);
  const instructionsURL = `${getBackendServerUrl()}${ROUTE_PATH.DOWNLOAD}`;

  if (!mobileWebAppURL) {
    return null;
  }

  return (
    <div className={styles.root}>
      <p className={styles.title}>{t(dictionary.title)}</p>
      <Link to={downloadModalLink}
            data-ga-event="footer-downloadApk"
            className={styles.phone} >
        <QRCode size={100}
                value={isQRtoInstructions ? instructionsURL : mobileWebAppURL}
                searchParams={{ from: FROM_WHERE, lang }} />
      </Link>
    </div>
  );
};
